<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
    <template v-for="(value, index) in valuesToShow" :key="`label-${index}`">
      <slot :props-value="$props" :label-class-value="labelClass" :loop-value="value" />
      <br
        v-if="lineBreakEvery !== null && (index + 1) % lineBreakEvery === 0"
        :key="`break-${index}`"
      />
    </template>
    <BaseLabel
      v-if="showCollapseButton && isCollapsed"
      v-bind="$props"
      class="pointer"
      @click="isCollapsed = false"
    >
      {{ showMoreText }}
    </BaseLabel>
  </div>
</template>

<script>
import BaseLabel from '@/components/BaseLabel.vue'

export default {
  components: { BaseLabel },
  props: {
    labelClass: {
      type: String,
      default: null,
      required: false,
    },
    default: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    quiet: {
      type: Boolean,
      default: false,
    },
    basic: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    numberOfInitialElements: {
      type: Number,
      default: 5,
      required: false,
    },
    lineBreakEvery: {
      type: [Number, null],
      default: 6,
      required: false,
    },
    values: {
      type: Array,
      required: true,
    },
    showMoreText: {
      type: String,
      default: '...',
      required: false,
    },
  },
  data() {
    return {
      isCollapsed: true,
    }
  },
  computed: {
    showCollapseButton() {
      return this.numberOfInitialElements < this.values.length
    },
    valuesToShow() {
      if (this.isCollapsed) {
        return this.values.slice(0, this.numberOfInitialElements)
      }
      return this.values
    },
  },
}
</script>
